module.exports = __webpack_public_path__ + "img/more-icon.d316b197.svg";